import { lazy } from 'react';
import { Compass, CreditCard, Film, Headset, Heart, Home, Sparkles, UserRound } from 'lucide-react';

import { getFeatureRegistry } from '@/core/features';
import { strings } from '@/lib/strings';

const loadHomePage = () => import('./home');
const loadCatalogPage = () => import('./catalog');
const loadCollectionPage = () => import('./collection');
const loadFavoritesPage = () => import('./favorites');
const loadProfilePage = () => import('./profile');
const loadHelpPage = () => import('./help');
const loadSetupPage = () => import('./setup');
const loadBillingPage = () => import('./billing');

const HomePage = lazy(() => loadHomePage().then((module) => ({ default: module.HomePage })));
const CatalogPage = lazy(() => loadCatalogPage().then((module) => ({ default: module.CatalogPage })));
const CollectionPage = lazy(() => loadCollectionPage().then((module) => ({ default: module.CollectionPage })));
const FavoritesPage = lazy(() => loadFavoritesPage().then((module) => ({ default: module.FavoritesPage })));
const ProfilePage = lazy(() => loadProfilePage().then((module) => ({ default: module.ProfilePage })));
const HelpPage = lazy(() => loadHelpPage().then((module) => ({ default: module.HelpPage })));
const SetupPage = lazy(() => loadSetupPage().then((module) => ({ default: module.SetupPage })));
const BillingPage = lazy(() => loadBillingPage().then((module) => ({ default: module.BillingPage })));

export function initializeFeatures(): void {
  const registry = getFeatureRegistry();

  registry.clear();
  registry.register({ id: 'home', name: strings.nav.home, icon: Home, route: '/home', component: HomePage, preload: loadHomePage, order: 0 });
  registry.register({ id: 'catalog', name: strings.nav.explore, icon: Compass, route: '/catalog', component: CatalogPage, preload: loadCatalogPage, order: 1 });
  registry.register({ id: 'collection', name: strings.nav.myVideos, icon: Film, route: '/collection', component: CollectionPage, preload: loadCollectionPage, order: 2 });
  registry.register({ id: 'favorites', name: strings.nav.favorites, icon: Heart, route: '/favorites', component: FavoritesPage, preload: loadFavoritesPage, order: 3 });
  registry.register({ id: 'profile', name: strings.nav.account, icon: UserRound, route: '/profile', component: ProfilePage, preload: loadProfilePage, order: 4 });
  registry.register({ id: 'help', name: strings.nav.help, icon: Headset, route: '/help', component: HelpPage, preload: loadHelpPage, order: 5 });
  registry.register({ id: 'setup', name: strings.setup.title, icon: Sparkles, route: '/setup', component: SetupPage, preload: loadSetupPage, order: 99, hideFromNav: true });
  registry.register({ id: 'billing', name: strings.home.topUpCta, icon: CreditCard, route: '/billing', component: BillingPage, preload: loadBillingPage, order: 100, hideFromNav: true });
}
